import {
    Box,
    Typography,
} from '@mui/material'
import { Image } from 'antd'
import BG from '../../../assets//personal-loan/download-bg.jpg'
import AppGallery from '../../../assets/download/download_appgallery.png'
import GooglePlay from '../../../assets/download/download_googleplay.png'
import AppStore from '../../../assets/download/download_appstore.png'
import { GOOGLE_PLAY_STORE_LINK, APP_STORE_LINK, APP_GALLERY_LINK } from '../../../common/config'
import { useTranslation } from 'react-i18next'

export const SMAppDownload: React.FC = () => {

    const { t } = useTranslation()

    // ======================= GooglePlay
    const clickGooglePlay = () => {
        window.open(GOOGLE_PLAY_STORE_LINK)
    }

    // ======================= AppStore
    const clickAppStore = () => {
        window.open(APP_STORE_LINK)
    }

    // ======================= AppGallery
    const clickAppGallery = () => {
        window.open(APP_GALLERY_LINK)
    }

    // ======================= VIEWS
    return (
        <Box
            sx={{
                width: '100%',
                paddingLeft: '12px',
                paddingRight: '12px',
                paddingTop: '60px',
                paddingBottom: '60px'
            }}
        >
            <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                borderRadius: '10px',
                width: '100%',
                backgroundImage: `url(${BG})`,
                objectFit: 'cover',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                paddingTop: '30px',
            }}>
                <Typography fontSize={16} fontWeight={500} color={'#FFFFFF'} textAlign={'center'}>
                    {t('t250')}
                </Typography>

                <Typography fontSize={24} fontWeight={700} color={'#FFFFFF'} paddingTop={'15px'} paddingLeft={'22px'} paddingRight={'22px'} textAlign={'center'}>
                    {t('t251')}
                </Typography>

                <Typography fontSize={16} fontWeight={400} color={'#F0F0F0'} paddingTop={'15px'} textAlign={'center'} paddingLeft={'22px'} paddingRight={'22px'}>
                    {t('t252')}
                 </Typography>

                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    paddingTop: '20px',
                    paddingBottom: '20px'
                }}>
                    <Box
                        onClick={clickGooglePlay}
                        sx={{
                            cursor: 'pointer',
                        }}>
                        <Image src={GooglePlay} width={133} height={40} alt='' preview={false}></Image>
                    </Box>

                    <Box sx={{
                        width: '10px'
                    }}></Box>

                    <Box
                        onClick={clickAppStore}
                        sx={{
                            cursor: 'pointer',
                        }}>
                        <Image src={AppStore} width={133} height={40} alt='' preview={false}></Image>
                    </Box>

                    <Box sx={{
                        width: '10px'
                    }}></Box>

                    <Box
                        onClick={clickAppGallery}
                        sx={{
                            cursor: 'pointer',
                        }}>
                        <Image src={AppGallery} width={133} height={40} alt='' preview={false}></Image>
                    </Box>
                </Box>
            </Box>

        </Box >
    )
}

// ======================= EXPORT
export default SMAppDownload
